var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.7234 9.41415C11.2066 8.90075 11.2066 8.09991 10.7234 7.58651L5.8201 2.37675C5.56776 2.10864 5.14584 2.09585 4.87773 2.34819C4.60961 2.60054 4.59683 3.02245 4.84917 3.29057L9.75247 8.50033L4.84917 13.7101C4.59683 13.9782 4.60961 14.4001 4.87773 14.6525C5.14584 14.9048 5.56776 14.892 5.8201 14.6239L10.7234 9.41415Z",
    fill: "#98A2B3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcRight);
export default __webpack_public_path__ + "static/media/ic_right.1822938ca1e3539280435f93b34c1c5a.svg";
export { ForwardRef as ReactComponent };